export default {
  part_number       : '',
  revision          : '',
};
